export default "__VITE_ASSET__DvWsgVif__"